import { categories } from '@/mocks/categories';

export default function FeaturedGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-xs font-semibold text-accent-500 uppercase tracking-widest mb-3">Trending Now</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Featured Categories
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl">
            Our most popular CSSBuy Spreadsheet categories — hand-picked by the community and updated every week with fresh finds.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20sneakers%20and%20footwear%20displayed%20on%20a%20clean%20minimal%20white%20shelf%20with%20soft%20natural%20lighting%2C%20modern%20product%20photography%2C%20warm%20beige%20tones%2C%20elegant%20composition%20with%20subtle%20shadows&width=600&height=450&seq=cat-shoes&orientation=landscape"
                alt="Shoes category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                Shoes
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20premium%20hoodies%20and%20sweaters%20neatly%20folded%20on%20a%20wooden%20surface%2C%20soft%20warm%20ambient%20lighting%2C%20lifestyle%20product%20photography%2C%20cream%20and%20beige%20tones%2C%20minimalist%20aesthetic%2C%20gentle%20shadows&width=600&height=450&seq=cat-hoodies&orientation=landscape"
                alt="Hoodies Sweaters category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                Hoodies/Sweaters
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-913/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=High%20quality%20cotton%20t-shirts%20hanging%20on%20a%20modern%20wooden%20rack%2C%20bright%20natural%20daylight%20streaming%20through%2C%20warm%20neutral%20background%2C%20editorial%20fashion%20photography%20style%2C%20soft%20fabric%20textures%20visible&width=600&height=450&seq=cat-tshirts&orientation=landscape"
                alt="T-Shirts category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                T-Shirts
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Trendy%20jackets%20and%20outerwear%20displayed%20on%20minimalist%20wooden%20hangers%20against%20a%20warm%20cream%20wall%2C%20soft%20diffused%20window%20light%2C%20modern%20retail%20display%20aesthetic%2C%20natural%20beige%20tones&width=600&height=450&seq=cat-jackets&orientation=landscape"
                alt="Jackets category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                Jackets
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-920/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20accessories%20including%20watches%20bracelets%20and%20sunglasses%20arranged%20on%20a%20light%20marble%20surface%2C%20soft%20natural%20lighting%2C%20elegant%20product%20flat%20lay%20photography%2C%20warm%20ivory%20and%20beige%20tones&width=600&height=450&seq=cat-accessories&orientation=landscape"
                alt="Accessories category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                Accessories
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-921/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20backpacks%20and%20handbags%20displayed%20on%20a%20clean%20wooden%20shelf%2C%20warm%20ambient%20lighting%20from%20side%20window%2C%20modern%20minimalist%20product%20photography%2C%20soft%20cream%20and%20beige%20tones%2C%20natural%20wood%20textures&width=600&height=450&seq=cat-bags&orientation=landscape"
                alt="Bags category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                Bags
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-919/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Sports%20jerseys%20hanging%20neatly%20on%20wooden%20hangers%20against%20a%20warm%20cream%20colored%20wall%2C%20soft%20natural%20daylight%2C%20athletic%20lifestyle%20product%20photography%2C%20neutral%20beige%20tones%2C%20clean%20minimal%20aesthetic&width=600&height=450&seq=cat-jersey&orientation=landscape"
                alt="Jersey category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                Jersey
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-915/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
          >
            <div className="aspect-[4/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Casual%20pants%20and%20shorts%20folded%20beautifully%20on%20a%20light%20wooden%20surface%2C%20soft%20warm%20natural%20lighting%2C%20lifestyle%20fashion%20photography%2C%20cream%20and%20beige%20background%2C%20minimalist%20Scandinavian%20aesthetic&width=600&height=450&seq=cat-pants&orientation=landscape"
                alt="Pants Shorts category on CSSBuy Spreadsheet"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <span className="absolute top-3 right-3 px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold rounded-full">
                Popular
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                Pants/Shorts
              </h3>
              <p className="text-xs text-foreground-500 mt-1">Browse collection →</p>
            </div>
          </a>
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse All {categories.length} Categories
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}